import React from 'react';

const EducationVisual = ({ type }) => {
  const visuals = {
    'farm-to-table': (
      <div className="text-center p-8 bg-gradient-to-r from-green-50 to-green-100 rounded-lg">
        <div className="flex justify-between items-center text-3xl">
          <span>🌾</span>
          <span>→</span>
          <span>🚛</span>
          <span>→</span>
          <span>🏭</span>
          <span>→</span>
          <span>🚛</span>
          <span>→</span>
          <span>🛒</span>
          <span>→</span>
          <span>🏠</span>
        </div>
        <p className="mt-4 text-sm text-gray-600">Farm → Transport → Warehouse → Transport → Supermarket → Home</p>
        <p className="text-xs text-red-500 mt-2">5-6 handlings = 30-40% waste</p>
      </div>
    ),
    'pickup-delivery': (
      <div className="text-center p-8 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg">
        <div className="flex justify-center gap-4 text-4xl">
          <span>🚗</span>
          <span>+</span>
          <span>🚲</span>
          <span>+</span>
          <span>🚐</span>
          <span>=</span>
          <span>📦</span>
        </div>
        <p className="mt-4 text-sm text-gray-600">Anyone with carrying capacity can be a Pickup</p>
        <p className="text-xs text-blue-600 mt-2">Earn credits or cash delivering food</p>
      </div>
    ),
    'producer-farm': (
      <div className="text-center p-8 bg-gradient-to-r from-amber-50 to-amber-100 rounded-lg">
        <div className="flex justify-center gap-4 text-4xl">
          <span>🚜</span>
          <span>→</span>
          <span>🌱</span>
          <span>→</span>
          <span>📱</span>
          <span>→</span>
          <span>🏠</span>
        </div>
        <p className="mt-4 text-sm text-gray-600">Farm → Our Pickup → Consumer</p>
        <p className="text-xs text-amber-600 mt-2">Direct sales = higher margins</p>
        <p className="text-xs text-amber-500 mt-1">Save 5% on selling costs</p>
      </div>
    ),
    'hub-warehouse': (
      <div className="text-center p-8 bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg">
        <div className="flex justify-center gap-4 text-4xl">
          <span>🚜</span>
          <span>+</span>
          <span>🚜</span>
          <span>+</span>
          <span>🚜</span>
          <span>=</span>
          <span>🏪</span>
        </div>
        <p className="mt-4 text-sm text-gray-600">Multiple farms → One Hub → Consumers</p>
        <p className="text-xs text-orange-600 mt-2">10-20% transport cost savings</p>
        <p className="text-xs text-orange-500 mt-1">Consignment or direct purchase options</p>
      </div>
    ),
    'savings': (
      <div className="text-center p-8 bg-gradient-to-r from-green-50 to-green-100 rounded-lg">
        <div className="flex justify-center gap-4 text-4xl">
          <span>🛒</span>
          <span>+</span>
          <span>👥</span>
          <span>+</span>
          <span>🚜</span>
          <span>=</span>
          <span>💰</span>
        </div>
        <p className="mt-4 text-sm text-gray-600">Buyers + Kins + Producers = Everyone Saves</p>
        <p className="text-xs text-green-600 mt-2">Volume discounts, lower fees, shared transport</p>
        <p className="text-xs text-green-500 mt-1">Food credits, Kin discounts, lower vendor costs</p>
      </div>
    )
  };

  return visuals[type] || (
    <div className="text-center p-8 bg-gray-50 rounded-lg">
      <span className="text-4xl">🎨</span>
      <p className="text-sm text-gray-500 mt-2">Illustration coming soon</p>
    </div>
  );
};

export default EducationVisual;
